import { MarkerContent, MarkerProps } from './MarkerCommon'

/** Marker web implementation: Passthrough adapter. This design must be kept compatible for both the web and mobile libraries */
export function Marker(props: MarkerProps) {
  return <MarkerContent {...props} />
}
